// Function loadBioListBlock loads the BioListBlock class by dynamically importing the js on demand if needed

export function loadBioListBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-bio-list-block-chunk" */ '../widgets/bioListBlock').then(wg => {

		const { BioListBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="BioListBlock"]');

		if(!$wg) {
			// console.info('BioListBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="BioListBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new BioListBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new BioListBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the BioListBlock widget');

}
